module.exports = __webpack_public_path__ + "img/6.e6fe805c.jpg";